import { Breakpoint } from '@avensia/scope';

export const maxContentWidth = 1440;
export const pageNarrowBreakpoint = Breakpoint.Small;
export const pageNormalBreakpoint = Breakpoint.Large;
export const pageWideBreakpoint = Breakpoint.Huge;
